import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ stat }) => {
  const getChangeColor = (change) => {
    if (change > 0) return 'text-success';
    if (change < 0) return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = (change) => {
    if (change > 0) return 'TrendingUp';
    if (change < 0) return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <div className="flex items-start justify-between mb-4">
        <div className={`${stat?.iconBg} rounded-full p-3`}>
          <Icon name={stat?.icon} size={24} className={stat?.iconColor} />
        </div>
        {stat?.change !== undefined && (
          <div className={`flex items-center gap-1 ${getChangeColor(stat?.change)}`}>
            <Icon name={getChangeIcon(stat?.change)} size={16} />
            <span className="text-sm font-medium">{Math.abs(stat?.change)}%</span>
          </div>
        )}
      </div>
      <h3 className="text-3xl font-bold text-foreground mb-1">{stat?.value}</h3>
      <p className="text-sm text-muted-foreground">{stat?.label}</p>
      {stat?.subtitle && (
        <p className="text-xs text-muted-foreground mt-2">{stat?.subtitle}</p>
      )}
    </div>
  );
};

export default StatCard;